import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'eca-submit-error',
  templateUrl: './submit-error.component.html',
  styleUrls: ['./submit-error.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubmitErrorComponent {

  constructor() { }

}
